import { get, post } from 'axios'

export const getReportsGroups = () => get('reports/groups')

export const getReportsGroupsFiltered = groups =>
  post('reports/groups', { ...groups, consolidated: true })

export const createGroupsReportsFilter = groupsFilters =>
  post('reports/groups/filters', { groupsFilters })

export const getGroupsReportsFilter = () => get('reports/groups/filters')

export const createExportGroupsReports = groups =>
  post('reports/groups/export', { groups })

export default {
  getReportsGroups,
  getReportsGroupsFiltered,
  createGroupsReportsFilter,
  getGroupsReportsFilter,
  createExportGroupsReports,
}
